import axios from 'axios';
import getUrl from 'utils/getUrl';
import { generateApiError } from './utils/apiErrorMessages';

export default (collectionPath, surveyId, { headerId }) =>
  axios
    .delete(getUrl.apiV2(`${collectionPath}/${surveyId}/items/${headerId}`))
    .catch(generateApiError());
